import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  Input,
  Output,
  EventEmitter,
  ContentChild,
  TemplateRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Inject,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { ValidationError } from 'validation';
import { ValidationService } from './../validation/validation.service';
import { Control } from './../control/control';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
export interface SelectControlComponentOption {
  key: string;
  text: string;
  subtext?: string;
  icon?: string;
  iconColor?: 'primary' | 'accent' | 'warn' | 'disabled';
  data?: any;
}

@Component({
  selector: 'i-select-control',
  templateUrl: './select-control.component.html',
  styleUrls: ['./select-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectControlComponent extends Control implements OnInit, OnDestroy, OnChanges {
  @Input() inpPath: string;
  @Input() inpPathForValidation: string;
  @Input() inpModel: SelectControlComponentOption | null;
  @Input() inpOptions: SelectControlComponentOption[];
  @Input() inpClass: string = '';
  @Input() inpLabel: string;
  @Input() inpIsInRadioButtonsMode = false;
  @Input() inpDisabled: boolean = false;
  @Output() inpModelChange = new EventEmitter<SelectControlComponentOption | null>();
  @ContentChild(TemplateRef, { static: true }) template: TemplateRef<any>;

  readonly appearance?: MatFormFieldDefaultOptions['appearance'];
  private validationIndex: number;
  private dirty: boolean = false;

  constructor(
    private validationService: ValidationService,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_FORM_FIELD_DEFAULT_OPTIONS) private options: MatFormFieldDefaultOptions,
  ) {
    super();
    this.appearance = this.options.appearance;
  }

  ngOnInit() {
    const validationRegistration = this.validationService.register({
      path: this.inpPathForValidation,
      pathExact: true,
      consumer: (final: boolean, errors: ValidationError[]) => {
        if (final || this.dirty) {
          this.decorate(errors);
          this.showCurrentTooltip();
          this.cdr.markForCheck();
        }
      },
    });
    this.validationIndex = validationRegistration.regKey;
    this.dirty = validationRegistration.dirty;
  }

  ngOnChanges(changes: SimpleChanges): void {
    let inpModelChange = changes['inpModel'];
    if (inpModelChange) {
      if (!inpModelChange.isFirstChange()) {
        this.dirty = true;
        this.validationService.validate();
      }
    }
  }

  ngOnDestroy() {
    this.validationService.unregister(this.validationIndex, this.dirty);
  }

  focused(tooltip: MatTooltip) {
    this.showTooltip(tooltip);
  }

  blurred() {
    this.hideTooltip();
  }

  changed() {
    this.inpModelChange.emit(this.inpModel);
  }

  optionTrackBy(index: number, value: SelectControlComponentOption) {
    return value.key;
  }
}
